/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} This_Top_Sparrow_WorkInputs */

const fr_this_top_sparrow_work = /** @type {(inputs: This_Top_Sparrow_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changer le favicon`)
};

/**

* @param {This_Top_Sparrow_WorkInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const this_top_sparrow_work = /** @type {((inputs?: This_Top_Sparrow_WorkInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<This_Top_Sparrow_WorkInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_this_top_sparrow_work(inputs)
});